// src/services/api/users.service.ts

import { apiClient, makeApiRequest } from './client';
import { endpoints } from './config';
import { User } from './types';

export interface EmployeeNameInfo {
  name: string;
  username: string;
  role: string;
}

export class UsersService {
  async getUsers(role?: string): Promise<User[]> {
    const url = role ? `${endpoints.users.list}?role=${role}` : endpoints.users.list;
    return makeApiRequest(() =>
      apiClient.get<User[]>(url)
    );
  }

  // Get employee names map by employee ID
  async getEmployeeNames(): Promise<Record<number, EmployeeNameInfo>> {
    return makeApiRequest(() =>
      apiClient.get<Record<number, EmployeeNameInfo>>(endpoints.users.employeeNames)
    );
  }

  async getUserById(id: number): Promise<User> {
    return makeApiRequest(() => 
      apiClient.get<User>(endpoints.users.byId(id))
    );
  }

  async updateUser(id: number, updates: Partial<User>): Promise<User> {
    return makeApiRequest(() => 
      apiClient.put<User>(endpoints.users.update(id), updates)
    );
  }

  // Get only employees (useful for project assignment)
  // Sem fallback para dados fictícios: um erro aqui precisa aparecer, e não ser
  // mascarado por uma lista de funcionários inexistentes.
  async getEmployees(): Promise<User[]> {
    return this.getUsers('employee');
  }

  // Get only project managers
  async getProjectManagers(): Promise<User[]> {
    return this.getUsers('manager');
  }
}

export const usersService = new UsersService();
